import React from "react";
import styled from "styled-components";
import ReactTooltip from "react-tooltip";
import { CurrencyCode } from "../../../types/currency";
import EuroFlag from "./img/flags/eur.svg";
import GBPFlag from "./img/flags/gbp.svg";

const CurrencyFlag = (props: CurrencyFlagProps) => {
  const { currency } = props;
  if (!currency) {
    return null;
  }

  const label = `This is a ${currency} account`;

  let flag;

  switch (currency) {
    case "EUR":
      flag = EuroFlag;
      break;
    case "GBP":
      flag = GBPFlag;
      break;
  }

  return (
    <Wrapper>
      <FlagImg
        src={flag}
        alt={label}
        data-tip={label}
        data-for="flag-tooltip"
      />
      <ReactTooltip
        type="dark"
        aria-haspopup="true"
        id="flag-tooltip"
        place="bottom"
        effect="solid"
      />
    </Wrapper>
  );
};

type CurrencyFlagProps = {
  currency: CurrencyCode;
};

const FlagImg = styled.img`
  width: 30px;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
`;

export default CurrencyFlag;
